import {
  Box,
  Flex,
  Text,
  Table,
  Thead,
  Tbody,
  Th,
  Td,
  Tr,
} from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';

import { CreditAgreement } from '@finley-technologies/finley-types';

import { LoanProduct } from './LoanProduct';
import { StickyHeaderSection } from 'packages/common-frontend/components/StickyHeaderSection';
import { CreditAgreementSectionAccordionTable } from 'packages/creditAgreements/ui/CreditAgreementFullArtifact/property/CreditAgreementSectionAccordionTable';

const multiLoanProductHeaders: (keyof CreditAgreement.DomainEntity.MultiLoanProductConcentrationLimit)[] = [
  'name',
  'value',
  'description',
  'section',
  'loanProducts',
];

export const BorrowingBaseMechanics: React.FC<{
  borrowingBaseMechanics: CreditAgreement.DomainEntity.BorrowingBaseMechanicsWithEntities;
}> = ({ borrowingBaseMechanics }) => {
  const basePropertyKey = 'borrowingBaseMechanics';
  const sanitizedProperties = _.omit(
    borrowingBaseMechanics,
    'calcAgentMechanics',
  );
  const loanProducts =
    borrowingBaseMechanics.calcAgentMechanics?.loanProductMechanics || [];

  const multiLoanProductConcentrationLimits =
    borrowingBaseMechanics.calcAgentMechanics
      .multiLoanProductConcentrationLimits || [];

  return (
    <Box mt="40px">
      <StickyHeaderSection labelText="Borrowing Base Mechanics">
        <Box>
          <Flex alignItems="center" mb="2">
            <Text fontWeight="bold" fontSize="20px">
              Properties
            </Text>
          </Flex>
          <CreditAgreementSectionAccordionTable
            properties={sanitizedProperties}
            basePropertyKey={basePropertyKey}
          />
        </Box>

        <Box mt="20px">
          <Flex alignItems="center" mb="2" mt="2">
            <Text fontWeight="bold" fontSize="20px">
              Loan Products
            </Text>
          </Flex>
          {loanProducts && !!loanProducts.length ? (
            <Box mt="20px" mb="20px">
              {_.map(loanProducts, (lp) => {
                return (
                  <LoanProduct loanProductMechanics={lp} key={lp.entity.id} />
                );
              })}
            </Box>
          ) : (
            <Text>There are no loan products configured</Text>
          )}
        </Box>

        <Text fontSize="20px" fontWeight="bold">
          Multi-Loan Product Concentration Limits
        </Text>
        {_.isEmpty(multiLoanProductConcentrationLimits) && (
          <Text>No multi loan products have been configured</Text>
        )}
        {!_.isEmpty(multiLoanProductConcentrationLimits) && (
          <Table borderWidth="1px">
            <Thead>
              <Tr>
                {_.map(multiLoanProductHeaders, (header) => (
                  <Th>{_.startCase(header)}</Th>
                ))}
              </Tr>
            </Thead>
            <Tbody>
              {_.map(multiLoanProductConcentrationLimits, (mlp) => (
                <Tr key={_.camelCase(mlp.name)}>
                  {_.map(multiLoanProductHeaders, (header) => {
                    if (header === 'loanProducts') {
                      return (
                        <Td key={`${_.camelCase(mlp.name)}-${header}`}>
                          {_.map(mlp.loanProducts, (lp) => (
                            <Text key={lp.entity.name}>{lp.entity.name}</Text>
                          ))}
                        </Td>
                      );
                    }
                    return (
                      <Td key={`${_.camelCase(mlp.name)}-${header}`}>
                        {mlp[header]}
                      </Td>
                    );
                  })}
                </Tr>
              ))}
            </Tbody>
          </Table>
        )}
      </StickyHeaderSection>
    </Box>
  );
};
